import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Layout from '../Layout';
import './css/contact.css'
import emailjs from "emailjs-com";

function ContactUs() {

    const [form, setForm] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: ""
    })
    const [isLoading, setIsLoading] = useState(false)

     const validate = form.fullName === "" || form.email === "" || form.phone === "" || form.message  === "" || isLoading;

     console.log(validate)

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };


    const sendEmail = (e) => {
        e.preventDefault();

        console.log("sending" )
        setIsLoading(true);

        emailjs
            .send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                form,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )
            .then(
                (result) => {
                    console.log("Result: ", result)
                    if(result?.status === 200){
                        setForm({
                            fullName: "",
                            email: "",
                            phone: "",
                            message: ""
                        })
                        alert("Message sent successfully!");
                    }else{
                        alert("Something went wrong.. Please try again!");
                    }
                    setIsLoading(false);
                },
                (error) => {
                    console.log(error);
                    setIsLoading(false);
                    alert("Failed to send message. Please try again.");
                }
            );
    };

    return (
        <Layout>


            <section className='child-container'>
                <div className='dflex gap-4'>
                    <h1 className='getHelp wow animate__animated animate__fadeInDown' data-wow-duration='1s'>Get In Touch</h1>
                    <div className='d-flex align-items-center gap-4'>
                        <div className='lineOne wow animate__animated animate__fadeInLeft' data-wow-duration='1.5s' />
                        <p className='wow animate__animated animate__fadeInRight' data-wow-duration='1.5s'>Great! We are excited to hear from you and let's start something special.</p>
                    </div>
                </div>
            </section>


            <section className='child-container'>

                <div className='contact-section'>

                    <div className='contactSecOne'>
                        <p className=' wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Contact us using the<br /> following medium.</p>

                        <div className='list-section'>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Email</span>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>info@divsglobal.com</span>
                        </div>

                        <div className='list-section'>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Phone</span>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>+234 7045723443</span>
                        </div>

                        <div className='list-section'>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Address</span>
                            <span className=' wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>The Ample, Opposite PHC Garden Estate, Chief Tom Agbuiyi Road, GRA Phase 2 Port Harcourt.</span>
                        </div>

                    </div>
                    <div className='contactSecTwo'>

                        <div id='contact-form'>

                            <Form>

                                <FloatingLabel
                                    controlId="floatingInputName"
                                    label="Full Name"
                                    className="mb-3">
                                    <Form.Control type="text"
                                        placeholder="John Doe"
                                        name='fullName'
                                        required
                                        onChange={handleChange} value={form.fullName}
                                    />
                                </FloatingLabel>

                                <Row>
                                    <Col>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Email address"
                                            className="mb-3">
                                            <Form.Control type="email" placeholder="name@example.com"
                                                name='email'
                                                required
                                                onChange={handleChange} value={form.email}
                                            />
                                        </FloatingLabel>
                                    </Col>
                                    <Col>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Phone Number"
                                            className="mb-3">
                                            <Form.Control type="phone" placeholder="+234 000 000 00" name='phone'
                                                onChange={handleChange} 
                                                value={form.phone} 
                                                required/>
                                        </FloatingLabel>
                                    </Col>
                                </Row>

                                <FloatingLabel controlId="floatingTextarea2" label="What can we do for you">
                                    <Form.Control
                                        as="textarea"
                                        placeholder="What can we do for you"
                                        style={{ height: '100px' }} 
                                        name='message'
                                        required
                                        onChange={handleChange} value={form.message}
                                    />
                                </FloatingLabel>

                                <div className='mt-5 w-100 d-flex justify-content-end'>

                                    <button className="cta float-right" onClick={sendEmail} disabled={validate}>
                                      {isLoading ? "Sending Message..." : "Submit Message →"}
                                        </button>
                                </div>

                            </Form>
                        </div>

                    </div>

                </div>


            </section>


        </Layout>
    )

}

export default ContactUs